<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mx-2"
                  color="primary"
                  @click="dialogAyuda = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-help-circle
                </v-icon>
              </template>
              <span>Ver ayuda sobre el corte diario</span>
            </v-tooltip>

            Corte diario
            <v-spacer></v-spacer>

            <!-- VALIDAR LOS PAGOS -->
            <v-tooltip bottom color="blue" max-width="300" v-if="![18, 19, 17].includes(this.getdatosUsuarioERPERP.idpuesto)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="green" @click="dialogPlanteles = true" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-check</v-icon> Validar
                </v-btn>
              </template>
              <span>Validar los pagos del plantel seleccionado</span>
            </v-tooltip>

            <v-tooltip bottom color="blue" max-width="300" v-if="this.getdatosUsuarioERPERP.iderp == 568">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="green" @click="dialogPlanteles = true" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-check</v-icon> Validar
                </v-btn>
              </template>
              <span>Validar los pagos del plantel seleccionado</span>
            </v-tooltip>

            <v-tooltip bottom color="blue" max-width="300" v-if="puedeVerBotonValidar">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="teal" @click="abrirDialogValidarPeriodo" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-calendar-check</v-icon> Validar por plantel
                </v-btn>
              </template>
              <span>Validar corte por plantel en un periodo (máx. 15 días)</span>
            </v-tooltip>

            <!-- EXPORTAT EL EXCEL -->
            <v-tooltip bottom color="blue" max-width="300" v-if="![18, 19, 17, 88].includes(this.getdatosUsuarioERPERP.idpuesto) && (!validaPagos && !pagosRechazados )">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="green" @click="dialogIngresosCorte.estatus = true" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-auto-download</v-icon>
                </v-btn>
              </template>
              <span>Descargar reporte de ingresos automáticamente</span>
            </v-tooltip>

            <!-- EXPORTAT EL EXCEL -->
            <v-tooltip bottom color="blue" max-width="300" v-if="(!validaPagos && !pagosRechazados )">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="green" @click="exportar( tablaMovimientos )" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
              </template>
              <span>Exportar corte diario a Excel (formato 1)</span>
            </v-tooltip>

            <!-- EXPORTAT EL EXCEL -->
            <v-tooltip bottom color="blue" max-width="300" v-if="(!validaPagos && !pagosRechazados )">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" small dark color="green" @click="exportar2( tablaMovimientos )" tile v-bind="attrs" v-on="on">
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
              </template>
              <span>Exportar corte diario a Excel (formato 2)</span>
            </v-tooltip>

            <!-- IMPRIMIR CORTE  -->
            <v-tooltip bottom color="blue" max-width="300" v-if="(!validaPagos && !pagosRechazados )">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="orange"
                  class="mr-2"
                  @click="generarRecibo( )"
                  small
                  dark
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small left>mdi-cash-register</v-icon>
                  CORTE
                </v-btn>
              </template>
              <span>Generar e imprimir el recibo del corte diario</span>
            </v-tooltip>

            <!-- DIFERENCIAS  -->
            <v-tooltip bottom color="blue" max-width="300" v-if="![18, 19, 17, 88].includes(this.getdatosUsuarioERPERP.idpuesto)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  class="mr-2"
                  @click="dialogCifras = true"
                  small
                  dark
                  tile
                  v-bind="attrs"
                  v-on="on"
                ><v-icon left>mdi-currency-usd</v-icon>Diferencias</v-btn>
              </template>
              <span>Ver diferencias entre cifras esperadas y reales</span>
            </v-tooltip>

            <!-- ACTUALIZAR LA INFO -->
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="text-capitalize"
                  @click="consultar()"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </template>
              <span>Actualizar información del corte diario</span>
            </v-tooltip>

          </v-card-title>

          <!-- CONTENIDO -->
          <v-card-text class="">

            <!-- FILTROS  -->
            <v-row>
              <v-col cols="12" sm="4" lg="4" xl="3">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-autocomplete
                      filled
                      dense
                      :clearable="[18, 19, 17 ].includes( getdatosUsuarioERPERP.idpuesto) && getdatosUsuarioERPERP.iderp != 568 ? false : true "
                      v-model="plantel"
                      :items="planteles"
                      label="Selecciona un plantel"
                      persistent-hint
                      hide-details
                      item-text="plantel"
                      item-value="id_plantel"
                      :readonly="[18, 19, 17].includes( getdatosUsuarioERPERP.idpuesto) && ![568,7,626,161,2781,2797,2845].includes( getdatosUsuarioERPERP.iderp ) ? true : false "
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-autocomplete>
                  </template>
                  <span>Elige el plantel para consultar su corte diario</span>
                </v-tooltip>
              </v-col>

              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Fecha de incio"
                      filled
                      dense
                      clearable
                      v-model="fecha_corte"
                      type="date"
                      @keyup.enter="consultar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>Selecciona la fecha del corte a consultar</span>
                </v-tooltip>
              </v-col>

              <v-col
                cols="12"
                sm="4"
                lg="4"
                xl="4"
                v-if="plantel && fecha_corte && miCorte"
              >
                <v-card width="44" v-if="[1,2].includes( miCorte.estatus )" @click="verMotivoError = true, motivoError = miCorte.motivo">
                  <v-avatar
                    size="44"
                    :color="miCorte.estatus == 2 ? 'red' : 'green'"
                    rounded
                    class="elevation-1"
                  >
                    <v-icon
                      dark
                      color="white"
                      size="30"
                      v-if="miCorte.estatus == 1"
                    >
                      mdi-check
                    </v-icon>

                    <v-icon dark color="white" size="30" v-else-if="miCorte.estatus == 2">
                      mdi-close
                    </v-icon>
                  </v-avatar>
                </v-card>

                <v-chip color="blue"  dark v-else-if="miCorte.estatus == 0" >Pendiente</v-chip>
              </v-col>
            </v-row>

            <!-- Alerta para indicar que hay pagos con datos incompletos -->
            <v-row v-if="validaPagos">
              <v-col cols="12">
                <v-alert
                  dense
                  outlined
                  type="error"
                >
                  Tienes <strong>PAGOS</strong> con <strong>Tarjeta o Deposito</strong> sin datos completos
                </v-alert>
              </v-col>
            </v-row>

            <!-- Alerta de pagos rechazados -->
            <v-row v-if="pagosRechazados">
              <v-col cols="12">
                <v-alert
                  dense
                  outlined
                  type="error"
                >
                  Tienes <strong>PAGOS</strong> con estatus <strong>RECHAZADOS</strong> Favor de validarlos en: <strong>"VALIDAR PAGOS SUCURSAL"</strong>
                </v-alert>
              </v-col>
            </v-row>


            <v-row align="center">

              <!-- DESGLOSE DE LOS PAGOS; SOLO PARA VENDEDORAS -->
              <v-col cols="12" v-if="plantel" class="pa-0">
                <v-card class="transparent elevation-0">
                  <v-card-text class="black--text text-subtitle-1" v-if="![18, 19, 17].includes(this.getdatosUsuarioERPERP.idpuesto) && ( !validaPagos && !pagosRechazados )">
                    <b>Corte plantel: </b>
                      {{ corte_plantel }}
                    <br/>
                    <b>Diferencia global: </b>
                      $ {{ diferencia_global }}
                  </v-card-text>

                  <v-card-text class="black--text text-h6" v-else>
                    <b>Corte plantel: </b>
                      {{ corte_plantel }}
                    <br/>
                    <v-tooltip bottom color="blue" max-width="300" v-if="( !validaPagos && !pagosRechazados )">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="expand = !expand" color="primary" small v-bind="attrs" v-on="on">
                          {{ !expand ? 'Reporte completo' : 'Ocultar Reporte' }}
                        </v-btn>
                      </template>
                      <span>Ver o ocultar el desglose completo del reporte</span>
                    </v-tooltip>
                  </v-card-text>

                  <v-expand-transition>
                    <div v-if="expand">
                      <v-card max-width="500" class="shadowCard">
                        <v-list class="transparent">
                          <v-list-item>
                            <v-list-item-title>Diferencia</v-list-item-title>
                            <v-list-item-subtitle class="text-right">
                              {{ diferencia_total }}
                            </v-list-item-subtitle>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title>Pagos de tu suc. a otra suc.</v-list-item-title>
                            <v-list-item-subtitle class="text-right">
                              {{ pagos_otra_suc }}
                            </v-list-item-subtitle>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title>Pagos de otra suc. a tu suc.</v-list-item-title>
                            <v-list-item-subtitle class="text-right">
                              {{ pagos_de_otra_suc }}
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>

                        <v-list-item>
                            <v-list-item-title>Pagos propios.</v-list-item-title>
                            <v-list-item-subtitle class="text-right">
                              {{ pagos_propios }}
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-card>

                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>

              <v-col cols="12" v-if="plantel && ( !validaPagos && !pagosRechazados )" class="pa-0">
                <MisMovimientos :tablaPagosSucursal="tablaPagosSucursal" :plantel="plantel" :url_servidor="url_servidor"/>
              </v-col>

              <v-col cols="12" v-if="plantel && ( !validaPagos && !pagosRechazados )" class="pa-0">
                <MovimientosOtraSucursal  :pagosDesdeOtraSucursal="pagosDesdeOtraSucursal" :plantel="plantel" :url_servidor="url_servidor"/>
              </v-col>

              <v-col cols="12" class="pa-0" v-if="( !validaPagos && !pagosRechazados )">
                <MovimientosCorte :num_pagos="num_pagos" :desglose="desglose" :cambios="cambios" :url_servidor="url_servidor" :tablaMovimientos="tablaMovimientos" :plantel="plantel" @consultar="consultar"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog para diferencias -->
    <v-dialog
      v-model="dialogCifras"
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      max-width="800"
    >
      <v-card>
        <v-card-title primary-title>
          Cifras
          <v-spacer></v-spacer>
          <v-tooltip bottom color="blue" max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark color="green" @click="exportar(filterCifras)" v-bind="attrs" v-on="on">
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <span>Exportar cifras y diferencias a Excel</span>
          </v-tooltip>
        </v-card-title>
        <!-- Datos principales del usuario -->
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-tooltip bottom color="blue" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-radio-group v-model="mostrar_cifras_completas" row>
                      <v-radio label="Diferencias" :value="1"></v-radio>
                      <v-radio label="Todas" :value="2"></v-radio>
                    </v-radio-group>
                  </div>
                </template>
                <span>Filtrar solo diferencias o ver todas las cifras</span>
              </v-tooltip>
            </v-col>

            <v-col cols="4">
              <v-tooltip bottom color="blue" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="ciclo"
                    :items="ciclosUnicos"
                    label="Selecciona el ciclo"
                    v-bind="attrs"
                    v-on="on"
                    persistent-hint
                    hide-details
                    item-text="ciclo"
                    item-value="id_ciclo"
                  >
                  </v-autocomplete>
                </template>
                <span>Filtrar información por ciclo escolar</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersCifras"
            :items="filterCifras"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
            <template v-slot:item.diferencia="{ item }">
              {{ item.diferencia.toFixed(2) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom color="blue" max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialogCifras = false" small color="green" dark v-bind="attrs" v-on="on">
                Cerrar
              </v-btn>
            </template>
            <span>Cerrar ventana de diferencias</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Visor de imagen (mismo formato que tickets / incidencias) -->
    <ImagenVisor
      @close="cerrarDialogImagen"
      :isOpen="dialgImagen"
      :imagen="imagen"
      :imagenes="imagenesVisor"
      :indiceInicial="indiceImagenVisor"
      :baseUrl="baseUrlVisor"
    />

    <!-- Dialog de Ayuda -->
    <v-dialog
  v-model="dialogAyuda"
  persistent
  max-width="900"
>
  <v-card>

    <v-card-title class="text-h5">
      Ayuda — Documentación
    </v-card-title>

    <v-card-text>

      <div
        v-for="(video, index) in videosAyuda"
        :key="index"
        class="mb-6"
      >
        <h3 class="subtitle-1 font-weight-bold mb-2">
          {{ video.titulo }}
        </h3>

        <video
        v-if="video.url.includes('.mp4')"
          :src="video.url"
          controls
          controlslist="nodownload"
          style="width: 100%; border-radius: 12px;"
        ></video>

        <div v-if="video.url.includes('.pdf')">
          <embed type="application/pdf"
          :src="video.url"
          height="600" width="100%"></div>
      </div>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green darken-1" text @click="dialogAyuda = false" v-bind="attrs" v-on="on">
            Cerrar
          </v-btn>
        </template>
        <span>Cerrar ventana de ayuda</span>
      </v-tooltip>
    </v-card-actions>

  </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

    <IngresosCorte v-if="dialogIngresosCorte.estatus" :dialogIngresosCorte="dialogIngresosCorte" />

    <v-dialog
      v-model="dialogPlanteles"
      max-width="1100px"
    >
      <v-card class="elevation-0">
        <v-card-title primary-title>
          Validación de corte
        </v-card-title>
        <v-card-text>

          <div class="black--text text-h6">Corte efectivo: {{ totalEfectivo }}</div>
          <v-data-table
            dense
            :headers="headersValidar"
            :items="plantelesInbi"
            class="elevation-1"
            :items-per-page="plantelesInbi.length"
            hide-default-footer
          >
            <template v-slot:item.folio_corte="{ item }">
              <span v-if="esPlantelConsultado(item) && item.folio_corte">{{ item.folio_corte }}</span>
              <span v-else class="grey--text">—</span>
            </template>

            <template v-slot:item.monto_recibido="{ item }">
              <span v-if="esPlantelConsultado(item) && item.monto_recibido != null && item.monto_recibido !== ''">{{ formatMoneda(item.monto_recibido) }}</span>
              <span v-else class="grey--text">—</span>
            </template>

            <template v-slot:item.estatus="{ item }">
              <template v-if="esPlantelConsultado(item)">
                <v-chip v-if="item.estatus == 0" dark small color="blue">Pendiente</v-chip>
                <v-chip v-if="item.estatus == 1" dark small color="green">Aceptado</v-chip>
                <v-chip v-if="item.estatus == 2" dark small color="red">Rechazadp</v-chip>
              </template>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom color="blue" max-width="300" v-if="puedeRegistrarCorteEfectivo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="indigo" dark class="mt-2 mr-1" @click="abrirDialogCorteEfectivo(item)" v-bind="attrs" v-on="on">
                    Corte
                  </v-btn>
                </template>
                <span>{{ item.folio_corte ? 'Corregir corte en efectivo' : 'Registrar corte en efectivo' }}</span>
              </v-tooltip>
              <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="green" dark class="mt-2" @click="aceptarCorte( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-check</v-icon></v-btn>
                </template>
                <span>Aceptar y validar el corte</span>
              </v-tooltip>
              <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="red" dark class="mt-2" @click="confirmarRechazo( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-close</v-icon></v-btn>
                </template>
                <span>Rechazar el corte</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-divider class="my-2"></v-divider>

          <v-data-table
            dense
            :headers="headersValidar"
            :items="plantelesFast"
            class="elevation-1"
            :items-per-page="plantelesFast.length"
            hide-default-footer
          >
            <template v-slot:item.folio_corte="{ item }">
              <span v-if="esPlantelConsultado(item) && item.folio_corte">{{ item.folio_corte }}</span>
              <span v-else class="grey--text">—</span>
            </template>

            <template v-slot:item.monto_recibido="{ item }">
              <span v-if="esPlantelConsultado(item) && item.monto_recibido != null && item.monto_recibido !== ''">{{ formatMoneda(item.monto_recibido) }}</span>
              <span v-else class="grey--text">—</span>
            </template>

            <template v-slot:item.estatus="{ item }">
              <template v-if="esPlantelConsultado(item)">
                <v-chip v-if="item.estatus == 0" dark small color="blue">Pendiente</v-chip>
                <v-chip v-if="item.estatus == 1" dark small color="green">Aceptado</v-chip>
                <v-chip v-if="item.estatus == 2" dark small color="red">Rechazadp</v-chip>
              </template>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom color="blue" max-width="300" v-if="puedeRegistrarCorteEfectivo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="indigo" dark class="mt-2 mr-1" @click="abrirDialogCorteEfectivo(item)" v-bind="attrs" v-on="on">
                    Corte
                  </v-btn>
                </template>
                <span>{{ item.folio_corte ? 'Corregir corte en efectivo' : 'Registrar corte en efectivo' }}</span>
              </v-tooltip>
              <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="green" dark class="mt-2" @click="aceptarCorte( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-check</v-icon></v-btn>
                </template>
                <span>Aceptar y validar el corte</span>
              </v-tooltip>
              <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile x-small color="red" dark class="mt-2" @click="confirmarRechazo( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-close</v-icon></v-btn>
                </template>
                <span>Rechazar el corte</span>
              </v-tooltip>
            </template>

          </v-data-table>

        </v-card-text>
        <!-- Guardar la información  -->
        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              absolute
              right
              top
              small
              icon
              @click="dialogPlanteles = false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Cerrar ventana de validación</span>
        </v-tooltip>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogValidarPeriodo"
      max-width="1200px"
      scrollable
    >
      <v-card class="elevation-0">
        <v-card-title primary-title>
          Validar corte por plantel
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Fecha inicio"
                filled
                dense
                type="date"
                v-model="periodoValidar.fecha_inicio"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Fecha fin"
                filled
                dense
                type="date"
                v-model="periodoValidar.fecha_fin"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                filled
                dense
                clearable
                v-model="periodoValidar.id_plantel"
                :items="plantelesPeriodoItems"
                label="Plantel"
                item-text="plantel"
                item-value="id_plantel"
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="d-flex align-center">
              <v-btn small color="teal" dark class="mr-2" @click="consultarValidacionPeriodo" :loading="cargarPeriodo">
                <v-icon small left>mdi-magnify</v-icon>
                Consultar
              </v-btn>
              <v-btn
                small
                color="green"
                dark
                class="mr-2"
                @click="exportarValidacionPeriodoExcel"
                :disabled="!filasValidarPeriodo.length"
              >
                <v-icon small left>mdi-microsoft-excel</v-icon>
                Excel
              </v-btn>
              <v-btn
                v-if="puedeRegistrarCorteEfectivo && filasValidarPeriodo.length"
                small
                color="indigo"
                class="mr-2 white--text"
                :disabled="!filasSeleccionadasPeriodo.length"
                @click="abrirDialogCorteMasivo"
              >
                <v-icon small left>mdi-cash-multiple</v-icon>
                Registrar corte{{ filasSeleccionadasPeriodo.length ? ` (${filasSeleccionadasPeriodo.length} día${filasSeleccionadasPeriodo.length === 1 ? '' : 's'})` : '' }}
              </v-btn>
              <div class="black--text text-subtitle-1" v-if="filasValidarPeriodo.length">
                Corte efectivo (periodo): {{ formatMoneda(totalEfectivoPeriodo) }}
              </div>
            </v-col>
          </v-row>

          <template v-if="filasValidarPeriodo.length">
            <template v-if="filasValidarPeriodoInbi.length">
            <div class="black--text text-subtitle-2 mt-3 mb-1">INBI</div>
            <v-data-table
              dense
              class="elevation-1"
              :headers="headersValidarPeriodo"
              :items="filasValidarPeriodoInbi"
              :items-per-page="filasValidarPeriodoInbi.length || 10"
              hide-default-footer
              group-by="plantel"
              :item-key="'_key'"
            >
              <template v-slot:group.header="{ group, items, isOpen, toggle }">
                <td :colspan="headersValidarPeriodo.length">
                  <v-btn x-small icon @click="toggle">
                    <v-icon small>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                  <v-simple-checkbox
                    v-if="puedeRegistrarCorteEfectivo && filasSeleccionablesPeriodo(items).length"
                    class="d-inline-flex"
                    :value="estadoGrupoPeriodo(items) === 'todos'"
                    :indeterminate="estadoGrupoPeriodo(items) === 'algunos'"
                    @input="toggleGrupoPeriodo(items, $event)"
                  ></v-simple-checkbox>
                  <strong>{{ group }}</strong>
                  <span class="grey--text ml-2">({{ items.length }} día{{ items.length === 1 ? '' : 's' }})</span>
                </td>
              </template>

              <template v-slot:item.fecha_corte="{ item }">
                <div class="d-flex align-center">
                  <v-simple-checkbox
                    v-if="puedeRegistrarCorteEfectivo"
                    class="mr-1"
                    :value="filaSeleccionadaPeriodo(item)"
                    :disabled="!esSeleccionablePeriodo(item)"
                    @input="toggleFilaPeriodo(item, $event)"
                  ></v-simple-checkbox>
                  {{ item.fecha_corte }}
                </div>
              </template>

              <template v-slot:item.efectivo="{ item }">
                {{ formatMoneda(item.efectivo_num != null ? item.efectivo_num : item.efectivo) }}
              </template>

              <template v-slot:item.folio_corte="{ item }">
                <span v-if="item.folio_corte">{{ item.folio_corte }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.monto_recibido="{ item }">
                <span v-if="item.monto_recibido != null && item.monto_recibido !== ''">{{ formatMoneda(item.monto_recibido) }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.estatus="{ item }">
                <v-chip v-if="item.estatus == 0" dark small color="blue">Pendiente</v-chip>
                <v-chip v-else-if="item.estatus == 1" dark small color="green">Aceptado</v-chip>
                <v-chip v-else-if="item.estatus == 2" dark small color="red">Rechazado</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom color="blue" max-width="300" v-if="puedeRegistrarCorteEfectivo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="indigo" dark class="mt-2 mr-1" @click="abrirDialogCorteEfectivo(item)" v-bind="attrs" v-on="on">
                      Corte
                    </v-btn>
                  </template>
                  <span>{{ item.folio_corte ? 'Corregir corte en efectivo' : 'Registrar corte en efectivo' }}</span>
                </v-tooltip>
                <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="green" dark class="mt-2" @click="aceptarCorte( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-check</v-icon></v-btn>
                  </template>
                  <span>Aceptar y validar el corte</span>
                </v-tooltip>
                <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="red" dark class="mt-2" @click="confirmarRechazo( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-close</v-icon></v-btn>
                  </template>
                  <span>Rechazar el corte</span>
                </v-tooltip>
              </template>
            </v-data-table>
            </template>

            <v-divider class="my-2" v-if="filasValidarPeriodoInbi.length && filasValidarPeriodoFast.length"></v-divider>

            <template v-if="filasValidarPeriodoFast.length">
            <div class="black--text text-subtitle-2 mb-1" :class="{ 'mt-3': !filasValidarPeriodoInbi.length }">FAST</div>
            <v-data-table
              dense
              class="elevation-1"
              :headers="headersValidarPeriodo"
              :items="filasValidarPeriodoFast"
              :items-per-page="filasValidarPeriodoFast.length || 10"
              hide-default-footer
              group-by="plantel"
              :item-key="'_key'"
            >
              <template v-slot:group.header="{ group, items, isOpen, toggle }">
                <td :colspan="headersValidarPeriodo.length">
                  <v-btn x-small icon @click="toggle">
                    <v-icon small>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                  <v-simple-checkbox
                    v-if="puedeRegistrarCorteEfectivo && filasSeleccionablesPeriodo(items).length"
                    class="d-inline-flex"
                    :value="estadoGrupoPeriodo(items) === 'todos'"
                    :indeterminate="estadoGrupoPeriodo(items) === 'algunos'"
                    @input="toggleGrupoPeriodo(items, $event)"
                  ></v-simple-checkbox>
                  <strong>{{ group }}</strong>
                  <span class="grey--text ml-2">({{ items.length }} día{{ items.length === 1 ? '' : 's' }})</span>
                </td>
              </template>

              <template v-slot:item.fecha_corte="{ item }">
                <div class="d-flex align-center">
                  <v-simple-checkbox
                    v-if="puedeRegistrarCorteEfectivo"
                    class="mr-1"
                    :value="filaSeleccionadaPeriodo(item)"
                    :disabled="!esSeleccionablePeriodo(item)"
                    @input="toggleFilaPeriodo(item, $event)"
                  ></v-simple-checkbox>
                  {{ item.fecha_corte }}
                </div>
              </template>

              <template v-slot:item.efectivo="{ item }">
                {{ formatMoneda(item.efectivo_num != null ? item.efectivo_num : item.efectivo) }}
              </template>

              <template v-slot:item.folio_corte="{ item }">
                <span v-if="item.folio_corte">{{ item.folio_corte }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.monto_recibido="{ item }">
                <span v-if="item.monto_recibido != null && item.monto_recibido !== ''">{{ formatMoneda(item.monto_recibido) }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.estatus="{ item }">
                <v-chip v-if="item.estatus == 0" dark small color="blue">Pendiente</v-chip>
                <v-chip v-else-if="item.estatus == 1" dark small color="green">Aceptado</v-chip>
                <v-chip v-else-if="item.estatus == 2" dark small color="red">Rechazado</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom color="blue" max-width="300" v-if="puedeRegistrarCorteEfectivo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="indigo" dark class="mt-2 mr-1" @click="abrirDialogCorteEfectivo(item)" v-bind="attrs" v-on="on">
                      Corte
                    </v-btn>
                  </template>
                  <span>{{ item.folio_corte ? 'Corregir corte en efectivo' : 'Registrar corte en efectivo' }}</span>
                </v-tooltip>
                <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="green" dark class="mt-2" @click="aceptarCorte( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-check</v-icon></v-btn>
                  </template>
                  <span>Aceptar y validar el corte</span>
                </v-tooltip>
                <v-tooltip bottom color="blue" max-width="300" v-if="![568,2268,2155,2472].includes( getdatosUsuarioERPERP.iderp )">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn tile x-small color="red" dark class="mt-2" @click="confirmarRechazo( item )" v-bind="attrs" v-on="on"><v-icon small>mdi-close</v-icon></v-btn>
                  </template>
                  <span>Rechazar el corte</span>
                </v-tooltip>
              </template>
            </v-data-table>
            </template>
          </template>
        </v-card-text>
        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn absolute right top small icon @click="dialogValidarPeriodo = false" v-bind="attrs" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Cerrar</span>
        </v-tooltip>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialogCorteEfectivo"
      max-width="560px"
      persistent
    >
      <v-card class="elevation-0" v-if="corteEfectivoForm">
        <v-card-title>
          {{ corteEfectivoForm.folio_corte ? 'Corregir corte en efectivo' : 'Registrar corte en efectivo' }}
        </v-card-title>
        <v-card-text>
          <div class="mb-2"><strong>Plantel:</strong> {{ corteEfectivoForm.plantel }}</div>
          <div class="mb-2" v-if="corteEfectivoForm.fecha_corte">
            <strong>Fecha corte:</strong> {{ corteEfectivoForm.fecha_corte }}
          </div>
          <div class="mb-2"><strong>Efectivo (corte):</strong> {{ formatMoneda(corteEfectivoForm.efectivo_corte) }}</div>
          <div class="caption mb-2" v-if="(corteEfectivoForm.ids_efectivo || []).length">
            Ingresos a validar: {{ (corteEfectivoForm.ids_efectivo || []).join(', ') }}
          </div>
          <div class="mb-2" v-if="corteEfectivoForm.folio_corte">
            <strong>Folio:</strong> {{ corteEfectivoForm.folio_corte }}
          </div>

          <v-alert
            v-if="errorCorteEfectivoVisible"
            type="error"
            dense
            outlined
            class="mb-3"
          >
            {{ mensajeErrorCorteEfectivo || 'El monto recibido debe coincidir exactamente con el efectivo del corte. Mientras haya diferencia, no se aceptará el corte.' }}
          </v-alert>

          <v-text-field
            label="Monto recibido (físico / corte)"
            type="number"
            step="0.01"
            min="0"
            filled
            dense
            clearable
            v-model.number="corteEfectivoForm.monto_recibido"
            :hint="hintDiferenciaCorte"
            persistent-hint
            :error="errorCorteEfectivoVisible"
            @input="limpiarErrorCorteEfectivo"
          ></v-text-field>

          <div class="mb-2" v-if="(corteEfectivoForm.evidencias_existentes || []).length">
            <div class="caption mb-1">Evidencias actuales</div>
            <div class="d-flex flex-wrap">
              <div
                v-for="(ev, idx) in corteEfectivoForm.evidencias_existentes"
                :key="'ev-' + idx"
                class="mr-2 mb-2"
                style="position: relative; display: inline-block;"
              >
                <a href="javascript:void(0)" @click.prevent="abrirEvidenciaCorte(ev, idx)">
                  <img
                    :src="urlComprobantePago(ev)"
                    alt="Evidencia corte"
                    width="90"
                    height="90"
                    style="object-fit: cover; border-radius: 4px; border: 1px solid #ddd; display: block;"
                  />
                </a>
                <v-btn
                  x-small
                  fab
                  dark
                  color="red"
                  style="position: absolute; top: -8px; right: -8px;"
                  @click.stop="quitarEvidenciaExistente(idx)"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="mb-2" v-if="(archivosCorteNuevos || []).length">
            <div class="caption mb-1">Fotos por subir ({{ archivosCorteNuevos.length }}) — clic para previsualizar</div>
            <div class="d-flex flex-wrap">
              <div
                v-for="(item, idx) in archivosCorteNuevos"
                :key="'nuevo-' + idx + '-' + ((item.file && item.file.name) || idx)"
                class="mr-2 mb-2"
                style="position: relative; display: inline-block;"
              >
                <a href="javascript:void(0)" @click.prevent="abrirPreviewArchivosNuevos(idx)">
                  <img
                    :src="item.previewUrl"
                    :alt="(item.file && item.file.name) || ('foto-' + (idx + 1))"
                    width="90"
                    height="90"
                    style="object-fit: cover; border-radius: 4px; border: 1px solid #ddd; display: block; cursor: pointer;"
                  />
                </a>
                <v-btn
                  x-small
                  fab
                  dark
                  color="red"
                  style="position: absolute; top: -8px; right: -8px;"
                  @click.stop="quitarArchivoCorteNuevo(idx)"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <input
            ref="inputFotosCorte"
            type="file"
            accept="image/*"
            multiple
            style="display: none"
            @change="onSeleccionarFotosCorte"
          />
          <v-btn
            color="indigo"
            outlined
            small
            class="mb-2"
            @click="$refs.inputFotosCorte && $refs.inputFotosCorte.click()"
          >
            <v-icon left small>mdi-camera</v-icon>
            Agregar fotos
          </v-btn>
          <div class="caption grey--text mb-2">
            Puede agregar varias fotos.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="cerrarDialogCorteEfectivo">Cancelar</v-btn>
          <v-btn color="indigo" dark tile small :loading="cargar" @click="guardarCorteEfectivo">
            Guardar corte
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCorteMasivo"
      max-width="640px"
      persistent
      scrollable
    >
      <v-card class="elevation-0" v-if="corteMasivoForm">
        <v-card-title>
          Registrar corte en efectivo ({{ corteMasivoForm.dias.length }} día{{ corteMasivoForm.dias.length === 1 ? '' : 's' }})
        </v-card-title>
        <v-card-text>
          <div class="mb-2"><strong>Plantel:</strong> {{ corteMasivoForm.plantel }}</div>

          <v-alert
            v-if="corteMasivoForm.error"
            type="error"
            dense
            outlined
            class="mb-3"
          >
            {{ corteMasivoForm.error }}
          </v-alert>

          <v-simple-table dense class="mb-3">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Efectivo (corte)</th>
                <th>Monto recibido</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dia in corteMasivoForm.dias" :key="dia.fecha_corte">
                <td>
                  {{ dia.fecha_corte }}
                  <div v-if="dia.folio_corte" class="caption grey--text">{{ dia.folio_corte }}</div>
                </td>
                <td>{{ formatMoneda(dia.efectivo_corte) }}</td>
                <td style="min-width: 200px;" class="py-2">
                  <v-text-field
                    type="number"
                    step="0.01"
                    min="0"
                    filled
                    dense
                    v-model.number="dia.monto_recibido"
                    :error-messages="dia.error ? [dia.error] : []"
                    :hint="hintDiferenciaDiaMasivo(dia)"
                    persistent-hint
                    @input="dia.error = ''; corteMasivoForm.error = ''"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <div class="mb-3">
            <strong>Total efectivo:</strong> {{ formatMoneda(totalesCorteMasivo.efectivo) }}
            <span class="ml-4"><strong>Total recibido:</strong> {{ formatMoneda(totalesCorteMasivo.recibido) }}</span>
          </div>

          <div class="mb-2" v-if="(archivosCorteNuevos || []).length">
            <div class="caption mb-1">Fotos por subir ({{ archivosCorteNuevos.length }}) — clic para previsualizar</div>
            <div class="d-flex flex-wrap">
              <div
                v-for="(item, idx) in archivosCorteNuevos"
                :key="'masivo-' + idx + '-' + ((item.file && item.file.name) || idx)"
                class="mr-2 mb-2"
                style="position: relative; display: inline-block;"
              >
                <a href="javascript:void(0)" @click.prevent="abrirPreviewArchivosNuevos(idx)">
                  <img
                    :src="item.previewUrl"
                    :alt="(item.file && item.file.name) || ('foto-' + (idx + 1))"
                    width="90"
                    height="90"
                    style="object-fit: cover; border-radius: 4px; border: 1px solid #ddd; display: block; cursor: pointer;"
                  />
                </a>
                <v-btn
                  x-small
                  fab
                  dark
                  color="red"
                  style="position: absolute; top: -8px; right: -8px;"
                  @click.stop="quitarArchivoCorteNuevo(idx)"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <input
            ref="inputFotosCorteMasivo"
            type="file"
            accept="image/*"
            multiple
            style="display: none"
            @change="onSeleccionarFotosCorte"
          />
          <v-btn
            color="indigo"
            outlined
            small
            class="mb-2"
            @click="$refs.inputFotosCorteMasivo && $refs.inputFotosCorteMasivo.click()"
          >
            <v-icon left small>mdi-camera</v-icon>
            Agregar fotos
          </v-btn>
          <div class="caption grey--text mb-2">
            Las fotos se agregan como evidencia a todos los días seleccionados. Los días que ya tenían corte conservan sus evidencias anteriores.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="cerrarDialogCorteMasivo">Cancelar</v-btn>
          <v-btn color="indigo" dark tile small :loading="cargar" @click="guardarCorteMasivo">
            Guardar corte
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogConfirma"
      max-width="550px"
    >
      <v-card class="elevation-0">
        <v-card-title primary-title>
          Ingresa el motivo de rechazo
        </v-card-title>
        <v-card-text>
          <v-tooltip bottom color="blue" max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="Ingresa el motivo de rechazo"
                filled
                v-model="motivo"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <span>Describe el motivo por el cual rechazas el corte</span>
          </v-tooltip>
        </v-card-text>
        <!-- Guardar la información  -->
        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              absolute
              right
              top
              small
              icon
              class="elevation-6"
              @click="dialogConfirma = false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Cerrar sin guardar</span>
        </v-tooltip>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom color="blue" max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="green"
                dark
                tile
                small
                @click="rechazarComprobante( datosPago )"
                v-bind="attrs"
                v-on="on"
              >
                Guardar
              </v-btn>
            </template>
            <span>Guardar motivo y rechazar el corte</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog
      v-model="verMotivoError"
      max-width="550px"
    >
      <v-card class="elevation-0">
        <v-card-title primary-title>
          Detalle del corte
        </v-card-title>
        <v-card-text>
          <v-textarea
            label="Ingresa el motivo de rechazo"
            filled
            readonly
            :rows="3"
            auto-grow
            v-model="motivoError"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom color="blue" max-width="300" v-if="miCorte && miCorte.estatus == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="orange" dark @click="solicitarRevision( )" v-bind="attrs" v-on="on">Solicitar revisión</v-btn>
            </template>
            <span>Solicitar una revisión del corte rechazado</span>
          </v-tooltip>
        </v-card-actions>
        <!-- Guardar la información  -->
        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              absolute
              right
              top
              small
              icon
              class="elevation-6"
              @click="verMotivoError = false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Cerrar detalles del corte</span>
        </v-tooltip>
      </v-card>

    </v-dialog>

  </v-container>
</template>
<script>
import axios from 'axios';

import { mapGetters } from "vuex";
// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import carga  from "@/components/alertas/carga.vue";

import MisMovimientos           from "@/components/corte/MisMovimientos.vue";
import MovimientosOtraSucursal  from "@/components/corte/MovimientosOtraSucursal.vue";
import MovimientosCorte         from "@/components/corte/MovimientosCorte.vue";
import IngresosCorte            from "@/components/corte/IngresosCorte.vue";
import ImagenVisor              from "@/views/operaciones/rh/ImagenIncidencia.vue";

import validarErrores           from "@/mixins/validarErrores";

import XLSX from "xlsx";

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default {
  components: {
    Alerta,
    carga,
    MisMovimientos,
    MovimientosOtraSucursal,
    MovimientosCorte,
    IngresosCorte,
    ImagenVisor,
  },

  mixins: [ validarErrores ],

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    fecha_corte: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    planteles: [],
    plantel: null,
    fullscreen: false,
    dialogCifras: false,
    url_servidor: null,
    fullscreen: false,
    dialogDiferencias:false,

    url_servidor: null,             //Angel Rodriguez
    dialgImagen: false,
    imagen: null,
    imagenesVisor: [],
    indiceImagenVisor: 0,
    archivosCorteNuevos: [],
    /** '' = preview local (blob); si no, comprobante-pago del API */
    baseUrlVisor: '',

    snackbar: false,

    headers: [
      { text: "id"           , value: "id_plantel" },
      { text: "Plantel"      , value: "plantel"      , align: "right" },
      { text: "Efectivo"     , value: "efectivo"     , align: "right" },
      { text: "Transferencia", value: "transferencia", align: "right" },
      { text: "Depositos"    , value: "depositos"    , align: "right" },
      { text: "Tarjeta"      , value: "tarjeta"      , align: "right" },
      { text: "Total"        , value: "total"        , align: "right" },
    ],

    headersCifras: [
      { text: "id"           , value: "id_ciclo"      },
      { text: "Ciclo"        , value: "ciclo"         },
      { text: "Plantel"      , value: "plantel"       },
      { text: "Cifra inicial", value: "cifra_inicial" },
      { text: "Cifra final"  , value: "cifra_final"   },
      { text: "Diferencia"   , value: "diferencia"    },
    ],

    headersDiferencias: [
      { text: "Plantel"     , value: "plantel"        },
      { text: "ERP viejo"   , value: "cifraERPVIEJO"  },
      { text: "ERP nuevo"   , value: "cifraERPNUEVO"  },
      { text: "Diferencia"  , value: "diferenteMonto" },
    ],

    headersValidar: [
      { text: "Plantel"  , value: "plantel"  },
      { text: "Efectivo" , value: "efectivo" },
      { text: "Recibido" , value: "monto_recibido" },
      { text: "Folio"    , value: "folio_corte" },
      { text: "Estatus"  , value: "estatus"  },
      { text: "Motivo"   , value: "motivo"   },
      { text: "Actions"  , value: "actions"  },
    ],

    diferencias:[],

    dialogCorteEfectivo: false,
    corteEfectivoForm: null,
    errorCorteEfectivoVisible: false,
    mensajeErrorCorteEfectivo: '',

    tablaPagosSucursal: [],
    desglose: [],
    cifras: [],
    pagosDesdeOtraSucursal: [],
    diferencia_total: 0,
    corte_plantel: 0,
    pagos_otra_suc: 0,
    pagos_propios: 0,
    pagos_de_otra_suc: 0,
    diferencia_global: 0,
    cifra_inicial: 0,
    cifra_final: 0,

    mostrar_cifras_completas: 1,
    ciclosUnicos: [],
    ciclo: null,
    searchMovimientos:'',

    expand: false,

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,

    cicloDiferencia:null,

    parametosComparativa:{
      estatus: false
    },
    cambios:[],
    num_pagos: 0,
    tablaMovimientos:[],
    dialogIngresosCorte: {
      estatus: false
    },
    rechazados:[],
    dialogPlanteles: false,
    dialogValidarPeriodo: false,
    cargarPeriodo: false,
    periodoValidar: {
      fecha_inicio: null,
      fecha_fin: null,
      id_plantel: null,
    },
    filasValidarPeriodo: [],
    totalEfectivoPeriodo: 0,
    seleccionCortePeriodo: [],
    dialogCorteMasivo: false,
    corteMasivoForm: null,
    headersValidarPeriodo: [
      { text: 'Fecha', value: 'fecha_corte' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Efectivo', value: 'efectivo' },
      { text: 'Recibido', value: 'monto_recibido' },
      { text: 'Folio', value: 'folio_corte' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Motivo', value: 'motivo' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    plantelesInbi:[],
    plantelesFast:[],
    datosPago: null,
    dialogConfirma: false,
    motivo:'',
    miCorte: null,
    verMotivoError: false,
    motivoError: '',
    totalEfectivo: 0,

    dialogAyuda: false,
    videosAyuda: [
      {
        titulo: 'Corte Diario',
        url: 'https://academicokpi.club/capacitacion-archivos/084309a6-314d-4015-8873-33967ddbb264.pdf'
      },
    ],


  }),

  watch: {
    plantel(value) {
      if (value && this.fecha_corte) {
        this.consultar();
      }
    },

    fecha_corte(value) {
      if (value && this.plantel) {
        this.consultar();
      }
    },

    cicloDiferencia( value ){
      if(value){ this.getDiferenciaCiclos() }
    },

  },

  computed: {
    ...mapGetters("login", ["getdatosUsuarioERPERP"]),

    puedeRegistrarCorteEfectivo() {
      // 56 Jefe administración, 11 Jefe de TI, 12 Desarrollador de software
      return [56, 11, 12].includes(Number((this.getdatosUsuarioERPERP || {}).idpuesto))
    },

    puedeVerBotonValidar() {
      const u = this.getdatosUsuarioERPERP || {}
      if (Number(u.iderp) === 568) return true
      return ![18, 19, 17].includes(Number(u.idpuesto))
    },

    plantelesPeriodoItems() {
      const base = Array.isArray(this.planteles) ? this.planteles.slice() : []
      return [{ id_plantel: '', plantel: 'Todos' }].concat(base)
    },

    filasValidarPeriodoInbi() {
      return (this.filasValidarPeriodo || []).filter((el) => Number(el.escuela) === 1)
    },

    filasValidarPeriodoFast() {
      return (this.filasValidarPeriodo || []).filter((el) => Number(el.escuela) === 2)
    },

    filasSeleccionadasPeriodo() {
      const keys = new Set(this.seleccionCortePeriodo || [])
      return (this.filasValidarPeriodo || [])
        .filter((el) => keys.has(el._key))
        .sort((a, b) => String(a.fecha_corte).localeCompare(String(b.fecha_corte)))
    },

    totalesCorteMasivo() {
      const dias = (this.corteMasivoForm && this.corteMasivoForm.dias) || []
      let efectivo = 0
      let recibido = 0
      for (const dia of dias) {
        efectivo += Number(dia.efectivo_corte) || 0
        recibido += Number(dia.monto_recibido) || 0
      }
      return {
        efectivo: Math.round(efectivo * 100) / 100,
        recibido: Math.round(recibido * 100) / 100,
      }
    },

    baseUrlComprobante() {
      const base = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '')
        .replace(/\/?$/, '/')
      if (base && base !== '/') return base + 'comprobante-pago'
      return String(this.url_servidor || '').replace(/\/?$/, '/') + 'comprobante-pago'
    },

    archivosCorteNuevosFiles() {
      return (this.archivosCorteNuevos || [])
        .map((item) => (item && item.file) || item)
        .filter(Boolean)
    },

    hintDiferenciaCorte() {
      const form = this.corteEfectivoForm
      if (!form) return ''
      const recibido = Number(form.monto_recibido)
      const sistema = Number(form.efectivo_corte) || 0
      if (form.monto_recibido === null || form.monto_recibido === '' || !Number.isFinite(recibido)) {
        return 'Capture el monto.'
      }
      const diff = Math.round((recibido - sistema) * 100) / 100
      if (Math.abs(diff) < 0.01) {
        return 'Coincide con el efectivo del corte. Se puede aceptar.'
      }
      const signo = diff > 0 ? '+' : ''
      return `Diferencia vs efectivo del corte: ${signo}${this.formatMoneda(diff)}. No se aceptará el corte hasta que coincida.`
    },

    corteEfectivoCuadra() {
      const form = this.corteEfectivoForm
      if (!form) return false
      if (form.monto_recibido === null || form.monto_recibido === '') return false
      const recibido = Number(form.monto_recibido)
      const sistema = Number(form.efectivo_corte) || 0
      if (!Number.isFinite(recibido)) return false
      return Math.abs(recibido - sistema) < 0.01
    },

    filterCifras( ) {
      let cifras = this.cifras;

      if (this.mostrar_cifras_completas == 1) {
        cifras = cifras.filter((el) => {
          return el.diferencia > 0;
        });
      }

      if (this.ciclo) {
        cifras = cifras.filter((el) => {
          return el.id_ciclo == this.ciclo;
        });
      }

      return cifras;
    },

    validaPagos( ){

      let data = this.tablaMovimientos

      data = data.filter( el => { return [2,4].includes( el.id_forma_pago ) })

      data = data.filter( el => !el.aut_clave_rastreo || !el.folio_operacion || !el.cuenta )

      if( [1,334,28].includes ( this.getdatosUsuarioERPERP.iderp ) ){ return false }

      return data.length > 0 ? true : false
    },

    filterEfectivo( ){

      this.tablaMovimientos

    },

    pagosRechazados( ){


      return false

      if( this.getdatosUsuarioERPERP.iderp == 28 ){
        return false
      }

      let pagos = this.rechazados


      let mapIdPlanteles  = this.getdatosUsuarioERPERP.planteles.map((registro) => registro.idplantel);

      // María Esther Segura Canales
      if( this.getdatosUsuarioERPERP.iderp == 568 ){
        mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
      }

      if( [2781, 2797].includes( this.getdatosUsuarioERPERP.iderp ) ){
        mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
      }

      // Sofía Lizeth ARIAS
      if( this.getdatosUsuarioERPERP.iderp == 626 ){
        mapIdPlanteles = [1,2,3,4,5,6,21,22,23,24,32]
      }

      // ANDREA CENTENO
      if( this.getdatosUsuarioERPERP.iderp == 7 ){
        mapIdPlanteles = [29,10004]
      }

      // Patricia Salazar
      if( this.getdatosUsuarioERPERP.iderp == 161 ){
        mapIdPlanteles = [7,8,9,10,11,12,14,16]
      }

      // VERONICA LETICIA FERNANDEZ RODRIGUEZ — FAST ONLINE + FAST_RG (ticket 78142)
      if( this.getdatosUsuarioERPERP.iderp == 3091 ){
        mapIdPlanteles = [9,16]
      }

      // if( this.getdatosUsuarioERPERP.iderp == 1312 ){
      //   mapIdPlanteles = [27,5,31,17]
      // }


      // PIEDAD LOPEZ
      if( this.getdatosUsuarioERPERP.iderp == 1248 ){
        mapIdPlanteles = [11,7,8,10]
      }

      // María Isabel Rodríguez Mora
      if( this.getdatosUsuarioERPERP.iderp == 1196 ){
        mapIdPlanteles = [2,3,5]
      }

      // INGRID AURORA COVARRUBIAS HERNANDEZ
      if( this.getdatosUsuarioERPERP.iderp == 3220 ){
        mapIdPlanteles = [17,25]
      }

      // fernanda oliva espinosa
      if( this.getdatosUsuarioERPERP.iderp == 1489 ){
        mapIdPlanteles = [25,28,27,31,17]
      }

      // PAOLA ZUYIN RODRIGUEZ ZAPATA
      if( this.getdatosUsuarioERPERP.iderp == 1312 ){
        mapIdPlanteles = [24,1,23,22]
      }

      // KELLY GARCIA RODRIGUEZ
      if( this.getdatosUsuarioERPERP.iderp == 2843 ){
        mapIdPlanteles = [10015,28]
      }



      if( [18, 19, 17].includes(this.getdatosUsuarioERPERP.idpuesto) && this.getdatosUsuarioERPERP.iderp != 568 ) {

        if( [2781, 2797].includes( this.getdatosUsuarioERPERP.iderp ) ){
          mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
        }

        pagos = pagos.filter( el => mapIdPlanteles.includes( el.id_plantel_ingreso ) )

      }else{

        if( [2781, 2797].includes( this.getdatosUsuarioERPERP.iderp ) ){
          mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
        }

        pagos = pagos.filter( el => el.id_plantel_ingreso == this.getdatosUsuarioERPERP.id_plantel )

      }

      console.log( 'rechazados', pagos )


      return pagos.length > 0 ? true : false
      // return true

    }
  },

  created() {

    if( [18, 19, 17].includes(this.getdatosUsuarioERPERP.idpuesto) && this.getdatosUsuarioERPERP.iderp != 568 ){
      this.plantel = this.getdatosUsuarioERPERP.id_plantel
    }

    this.initialize();
    this.url_servidor = "https://escuelakpi.club/kpi/";

  },

  methods: {
    initialize() {
      this.cargar = true;
      this.planteles = [];
      this.$http.get("kpi.planteles.all").then((response) => {

        if ([18, 19, 17].includes(this.getdatosUsuarioERPERP.idpuesto) && this.getdatosUsuarioERPERP.iderp != 568 ) {
          this.planteles = response.data.filter((el) => {
            return el.id_plantel == this.getdatosUsuarioERPERP.id_plantel;
          });
        } else {
          this.planteles = response.data;
        }

        // María Esther Segura Canales
        if( this.getdatosUsuarioERPERP.iderp == 568 ){
          let mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // INGRID AURORA COVARRUBIAS HERNANDEZ
        if( this.getdatosUsuarioERPERP.iderp == 3220 ){
          let mapIdPlanteles = [17,25]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // NAOMI SARAI PALMA MENDEZ (2781) y 2797: todas las sucursales
        if( [2781, 2797].includes( this.getdatosUsuarioERPERP.iderp ) ){
          let mapIdPlanteles = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,10002,10003,10004]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // Sofía Lizeth ARIAS
        if( this.getdatosUsuarioERPERP.iderp == 626 ){
          let mapIdPlanteles = [1,2,3,4,5,6,21,22,23,24,32]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // ANDREA CENTENO
        if( this.getdatosUsuarioERPERP.iderp == 7 ){
          let mapIdPlanteles = [29,10004]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // Patricia Salazar
        if( this.getdatosUsuarioERPERP.iderp == 161 ){
          let mapIdPlanteles = [7,8,9,10,11,12,14,16]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // KELLY GARCIA RODRIGUEZ
        if( this.getdatosUsuarioERPERP.iderp == 2843 ){
          let mapIdPlanteles = [10015,28]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // VERONICA LETICIA FERNANDEZ RODRIGUEZ — FAST ONLINE + FAST_RG (ticket 78142)
        if( this.getdatosUsuarioERPERP.iderp == 3091 ){
          let mapIdPlanteles = [9,16]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        // iderp 2845: Lindavista y Montevideo (ticket 79845)
        if( this.getdatosUsuarioERPERP.iderp == 2845 ){
          let mapIdPlanteles = [10015,25]
          this.planteles = response.data.filter( el => mapIdPlanteles.includes( el.id_plantel ) )
        }

        this.cargar = false;
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    consultar() {
      this.tablaPagosSucursal     = [];
      this.desglose               = [];
      this.cifras                 = [];
      this.pagosDesdeOtraSucursal = [];
      this.diferencia_total       = 0;
      this.corte_plantel          = 0;
      this.pagos_otra_suc         = 0;
      this.pagos_propios          = 0;
      this.pagos_de_otra_suc      = 0;
      this.diferencia_global      = 0;
      this.cifra_inicial          = 0;
      this.cifra_final            = 0;
      this.rechazados             = 0;
      this.cargar                 = true;

      var payload = {
        fecha_corte: this.fecha_corte,
        id_plantel: this.plantel,
      };

      this.$http.post("corte.sucursal", payload).then((response) => {
        this.tablaPagosSucursal      = response.data.tablaPagosSucursal;
        this.desglose                = response.data.desglose;
        this.cifras                  = response.data.cifras;
        this.pagosDesdeOtraSucursal  = response.data.pagosDesdeOtraSucursal;
        this.diferencia_total        = response.data.diferencia_total;
        this.corte_plantel           = response.data.corte_plantel;
        this.pagos_otra_suc          = response.data.pagos_otra_suc;
        this.pagos_propios           = response.data.pagos_propios;
        this.pagos_de_otra_suc       = response.data.pagos_de_otra_suc;
        this.diferencia_global       = response.data.diferencia_global;
        this.cifra_inicial           = response.data.cifra_inicial;
        this.cifra_final             = response.data.cifra_final;
        this.ciclosUnicos            = response.data.ciclosUnicos;
        this.cambios                 = response.data.cambios;
        this.num_pagos               = response.data.num_pagos;
        this.tablaMovimientos        = response.data.tablaMovimientos;
        this.rechazados              = response.data.rechazados
        this.plantelesInbi           = response.data.plantelesInbi
        this.plantelesFast           = response.data.plantelesFast
        this.miCorte                 = response.data.miCorte
        this.cargar                  = false;

        this.corte_plantel    = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.corte_plantel )
        this.diferencia_total = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.diferencia_total )
        this.pagos_otra_suc   = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.pagos_otra_suc )
        this.pagos_propios    = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.pagos_propios )


        for( const i in this.tablaPagosSucursal ){
          let { efectivo, depositos, tarjeta, total, transferencia } = this.tablaPagosSucursal[i]
          this.tablaPagosSucursal[i].efectivo      = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( efectivo )
          this.tablaPagosSucursal[i].depositos     = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( depositos )
          this.tablaPagosSucursal[i].tarjeta       = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( tarjeta )
          this.tablaPagosSucursal[i].total         = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( total )
          this.tablaPagosSucursal[i].transferencia = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( transferencia )
        }

        for( const i in this.pagosDesdeOtraSucursal ){
          let { efectivo, depositos, tarjeta, total, transferencia } = this.pagosDesdeOtraSucursal[i]
          this.pagosDesdeOtraSucursal[i].efectivo      = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( efectivo )
          this.pagosDesdeOtraSucursal[i].depositos     = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( depositos )
          this.pagosDesdeOtraSucursal[i].tarjeta       = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( tarjeta )
          this.pagosDesdeOtraSucursal[i].total         = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( total )
          this.pagosDesdeOtraSucursal[i].transferencia = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( transferencia )
        }
        // Columna Efectivo: lógica histórica (suma desde tablaMovimientos del plantel consultado).
        // ids_efectivo_corte del API se prefieren al abrir/guardar Corte.
        for( const i in this.plantelesInbi ){

          const { id_plantel } = this.plantelesInbi[i]

          let movimientos = this.tablaMovimientos.filter( el => el.id_plantel_ingreso == id_plantel )
          let total = 0

          for( const j in movimientos ){

            let { monto_pagado, forma_pago } = movimientos[j]

            if( forma_pago == 'EFECTIVO'){

              total += Number(monto_pagado) || 0

            }

          }

          this.plantelesInbi[i]['efectivo_num'] = total
          this.plantelesInbi[i]['efectivo'] = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( total )
          // Ids de la ventana (movimientos consultados); si el API trae ids_efectivo_corte, se prefieren al abrir Corte.
          if (!Array.isArray(this.plantelesInbi[i].ids_efectivo_corte) || !this.plantelesInbi[i].ids_efectivo_corte.length) {
            this.plantelesInbi[i]['ids_efectivo_corte'] = movimientos
              .filter((el) => String(el.forma_pago || '').toUpperCase() === 'EFECTIVO')
              .map((el) => el.id_ingreso)
              .filter((id) => id != null)
          }
          if (this.plantelesInbi[i].efectivo_raw == null) {
            this.plantelesInbi[i]['efectivo_raw'] = 0
          }

        }


        for( const i in this.plantelesFast ){

          const { id_plantel } = this.plantelesFast[i]

          let movimientos = this.tablaMovimientos.filter( el => el.id_plantel_ingreso == id_plantel )
          let total = 0

          for( const j in movimientos ){

            let { monto_pagado, forma_pago } = movimientos[j]

            if( forma_pago == 'EFECTIVO'){

              total += Number(monto_pagado) || 0

            }

          }

          this.plantelesFast[i]['efectivo_num'] = total
          this.plantelesFast[i]['efectivo'] = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( total )
          if (!Array.isArray(this.plantelesFast[i].ids_efectivo_corte) || !this.plantelesFast[i].ids_efectivo_corte.length) {
            this.plantelesFast[i]['ids_efectivo_corte'] = movimientos
              .filter((el) => String(el.forma_pago || '').toUpperCase() === 'EFECTIVO')
              .map((el) => el.id_ingreso)
              .filter((id) => id != null)
          }
          if (this.plantelesFast[i].efectivo_raw == null) {
            this.plantelesFast[i]['efectivo_raw'] = 0
          }

        }

        this.totalEfectivo = 0

        for( const i in this.tablaMovimientos ){
          let { monto_pagado, forma_pago } = this.tablaMovimientos[i]

          if( forma_pago == 'EFECTIVO'){

            this.totalEfectivo += monto_pagado

          }
          this.tablaMovimientos[i].monto_pagado      = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( monto_pagado )
        }





        for( const i in this.desglose ){
          let { desglose, total } = this.desglose[i]

          for( const j in desglose ){
            let { monto_pagado } = desglose[j]
            this.desglose[i].desglose[j].monto_pagado      = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( monto_pagado )
          }

          this.desglose[i].total      = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( total )
        }


        this.totalEfectivo = new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.totalEfectivo )

      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },




    estatusCorteTexto(estatus) {
      if (estatus == 0 || estatus === '0') return 'Pendiente'
      if (estatus == 1 || estatus === '1') return 'Aceptado'
      if (estatus == 2 || estatus === '2') return 'Rechazado'
      return ''
    },

    filasPeriodoConEfectivo() {
      return (this.filasValidarPeriodo || []).filter((el) => {
        const n = Number(el && (el.efectivo_num != null ? el.efectivo_num : el.efectivo))
        return Number.isFinite(n) && n > 0
      })
    },

    filasPeriodoParaHojaExcel(filas) {
      const sorted = (filas || []).slice().sort((a, b) => {
        const pa = String((a && a.plantel) || '').localeCompare(String((b && b.plantel) || ''), 'es')
        if (pa !== 0) return pa
        return String((a && a.fecha_corte) || '').localeCompare(String((b && b.fecha_corte) || ''))
      })
      const headers = ['Fecha', 'Plantel', 'Efectivo', 'Recibido', 'Folio', 'Estatus', 'Motivo']
      const aoa = [headers]
      let lastPlantel = null
      for (let i = 0; i < sorted.length; i++) {
        const row = sorted[i]
        const plantel = row.plantel || ''
        if (lastPlantel !== null && plantel !== lastPlantel) {
          aoa.push([])
        }
        lastPlantel = plantel
        const efectivo = Number(row.efectivo_num != null ? row.efectivo_num : row.efectivo) || 0
        const recibido = row.monto_recibido != null && row.monto_recibido !== ''
          ? Number(row.monto_recibido)
          : ''
        aoa.push([
          row.fecha_corte || '',
          plantel,
          Math.round(efectivo * 100) / 100,
          recibido === '' || !Number.isFinite(recibido) ? '' : Math.round(recibido * 100) / 100,
          row.folio_corte || '',
          this.estatusCorteTexto(row.estatus),
          row.motivo || '',
        ])
      }
      return XLSX.utils.aoa_to_sheet(aoa)
    },

    exportarValidacionPeriodoExcel() {
      const filas = this.filasPeriodoConEfectivo()
      if (!filas.length) {
        this.validarErrorDirecto('No hay días con efectivo para descargar')
        return
      }
      const inbi = filas.filter((el) => Number(el.escuela) === 1)
      const fast = filas.filter((el) => Number(el.escuela) === 2)
      if (!inbi.length && !fast.length) {
        this.validarErrorDirecto('No hay días con efectivo para descargar')
        return
      }

      const workbook = XLSX.utils.book_new()
      if (inbi.length) {
        XLSX.utils.book_append_sheet(workbook, this.filasPeriodoParaHojaExcel(inbi), 'INBI')
      } else {
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.aoa_to_sheet([['Sin días con efectivo en INBI']]),
          'INBI'
        )
      }
      if (fast.length) {
        XLSX.utils.book_append_sheet(workbook, this.filasPeriodoParaHojaExcel(fast), 'FAST')
      } else {
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.aoa_to_sheet([['Sin días con efectivo en FAST']]),
          'FAST'
        )
      }

      const ini = (this.periodoValidar && this.periodoValidar.fecha_inicio) || ''
      const fin = (this.periodoValidar && this.periodoValidar.fecha_fin) || ''
      const filename = ('corte_periodo_' + ini + '_' + fin).replace(/[^a-zA-Z0-9_-]/g, '_')

      // Descarga directa en el navegador (evita ENOENT del endpoint pdfs)
      XLSX.writeFile(workbook, filename + '.xlsx')
    },

    abrirDialogValidarPeriodo() {
      const hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)
      this.periodoValidar = {
        fecha_inicio: this.fecha_corte || hoy,
        fecha_fin: this.fecha_corte || hoy,
        id_plantel: this.plantel != null && this.plantel !== '' ? this.plantel : '',
      }
      this.filasValidarPeriodo = []
      this.totalEfectivoPeriodo = 0
      this.seleccionCortePeriodo = []
      this.dialogValidarPeriodo = true
    },

    validarRangoPeriodoCorte() {
      const ini = this.periodoValidar && this.periodoValidar.fecha_inicio
      const fin = this.periodoValidar && this.periodoValidar.fecha_fin
      if (!ini || !fin) {
        this.validarErrorDirecto('Selecciona fecha de inicio y fecha fin')
        return false
      }
      const a = new Date(ini + 'T12:00:00')
      const b = new Date(fin + 'T12:00:00')
      if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime()) || b < a) {
        this.validarErrorDirecto('Rango de fechas inválido')
        return false
      }
      const dias = Math.round((b - a) / 86400000)
      if (dias > 14) {
        this.validarErrorDirecto('Elige un rango de máximo 15 días')
        return false
      }
      return true
    },

    consultarValidacionPeriodo() {
      if (!this.validarRangoPeriodoCorte()) return
      this.cargarPeriodo = true
      this.cargar = true
      const payload = {
        fecha_inicio: this.periodoValidar.fecha_inicio,
        fecha_fin: this.periodoValidar.fecha_fin,
        id_plantel: this.periodoValidar.id_plantel,
      }
      this.$http.post('validar.corte.periodo', payload).then((response) => {
        const data = (response && response.data) || {}
        this.filasValidarPeriodo = Array.isArray(data.filas) ? data.filas : []
        this.totalEfectivoPeriodo = Number(data.totalEfectivo) || 0
        this.seleccionCortePeriodo = []
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.cargarPeriodo = false
        this.cargar = false
      })
    },

    refrescarTrasAccionCorte() {
      if (this.dialogValidarPeriodo) {
        this.consultarValidacionPeriodo()
      }
      if (this.plantel && this.fecha_corte) {
        this.consultar()
      }
    },

    esSeleccionablePeriodo(item) {
      return !!item && Number(item.estatus) !== 1
    },

    filaSeleccionadaPeriodo(item) {
      return !!item && (this.seleccionCortePeriodo || []).includes(item._key)
    },

    filasSeleccionablesPeriodo(items) {
      return (items || []).filter((el) => this.esSeleccionablePeriodo(el))
    },

    estadoGrupoPeriodo(items) {
      const seleccionables = this.filasSeleccionablesPeriodo(items)
      if (!seleccionables.length) return 'ninguno'
      const marcados = seleccionables.filter((el) => this.filaSeleccionadaPeriodo(el)).length
      if (!marcados) return 'ninguno'
      return marcados === seleccionables.length ? 'todos' : 'algunos'
    },

    toggleFilaPeriodo(item, marcar) {
      if (!this.esSeleccionablePeriodo(item)) return
      const actuales = this.seleccionCortePeriodo || []
      if (!marcar) {
        this.seleccionCortePeriodo = actuales.filter((key) => key !== item._key)
        return
      }
      // Un solo plantel por corte masivo: marcar otro plantel reinicia la selección.
      const primera = this.filasSeleccionadasPeriodo[0]
      if (primera && Number(primera.id_plantel) !== Number(item.id_plantel)) {
        this.seleccionCortePeriodo = [item._key]
        return
      }
      if (!actuales.includes(item._key)) {
        this.seleccionCortePeriodo = actuales.concat(item._key)
      }
    },

    toggleGrupoPeriodo(items, marcar) {
      const keys = this.filasSeleccionablesPeriodo(items).map((el) => el._key)
      if (marcar) {
        this.seleccionCortePeriodo = keys
        return
      }
      const quitar = new Set(keys)
      this.seleccionCortePeriodo = (this.seleccionCortePeriodo || []).filter((key) => !quitar.has(key))
    },

    abrirDialogCorteMasivo() {
      const filas = this.filasSeleccionadasPeriodo
      if (!this.puedeRegistrarCorteEfectivo || !filas.length) return
      this.corteMasivoForm = {
        id_plantel: filas[0].id_plantel,
        plantel: filas[0].plantel,
        error: '',
        dias: filas.map((item) => ({
          fecha_corte: item.fecha_corte,
          folio_corte: item.folio_corte || null,
          efectivo_corte: Number(item.efectivo_num != null ? item.efectivo_num : item.efectivo) || 0,
          ids_efectivo: Array.isArray(item.ids_efectivo_corte) ? [...item.ids_efectivo_corte] : [],
          monto_recibido: null,
          error: '',
        })),
      }
      this.limpiarArchivosCorteNuevos()
      this.dialogCorteMasivo = true
    },

    cerrarDialogCorteMasivo() {
      this.dialogCorteMasivo = false
      this.corteMasivoForm = null
      this.limpiarArchivosCorteNuevos()
      if (this.$refs.inputFotosCorteMasivo) this.$refs.inputFotosCorteMasivo.value = ''
    },

    hintDiferenciaDiaMasivo(dia) {
      if (!dia) return ''
      const recibido = Number(dia.monto_recibido)
      if (dia.monto_recibido === null || dia.monto_recibido === '' || !Number.isFinite(recibido)) {
        return 'Capture el monto.'
      }
      const diff = Math.round((recibido - (Number(dia.efectivo_corte) || 0)) * 100) / 100
      if (Math.abs(diff) < 0.01) return 'Coincide con el efectivo del corte.'
      return `Diferencia: ${diff > 0 ? '+' : ''}${this.formatMoneda(diff)}`
    },

    async guardarCorteMasivo() {
      const form = this.corteMasivoForm
      if (!form || !this.puedeRegistrarCorteEfectivo) return

      let hayError = false
      for (const dia of form.dias) {
        dia.error = ''
        const recibido = Number(dia.monto_recibido)
        if (dia.monto_recibido === null || dia.monto_recibido === '' || !Number.isFinite(recibido) || recibido < 0) {
          dia.error = 'Captura el monto recibido'
          hayError = true
          continue
        }
        const diff = Math.round((recibido - (Number(dia.efectivo_corte) || 0)) * 100) / 100
        if (Math.abs(diff) >= 0.01) {
          dia.error = `No coincide con el efectivo (${diff > 0 ? '+' : ''}${this.formatMoneda(diff)})`
          hayError = true
        }
      }
      if (hayError) {
        form.error = 'Hay días sin monto o con diferencia. No se guardará ningún día hasta que todos coincidan.'
        return
      }

      const nuevos = this.archivosCorteNuevosFiles
      if (!nuevos.length) {
        form.error = 'Sube al menos una evidencia fotográfica'
        return
      }
      form.error = ''

      this.cargar = true
      let evidencias = []
      try {
        evidencias = await this.subirEvidenciasCorte(nuevos)
      } catch (error) {
        this.cargar = false
        this.validarError(error)
        return
      }

      const payload = {
        id_plantel: form.id_plantel,
        evidencias_corte: evidencias,
        dias: form.dias.map((dia) => ({
          fecha_corte: dia.fecha_corte,
          monto_recibido: Number(dia.monto_recibido),
          ids_ingresos: dia.ids_efectivo,
        })),
      }

      this.$http.post('registrar.corte.efectivo.masivo', payload).then((response) => {
        const mensaje = (response && response.data && response.data.message) || 'Corte en efectivo registrado'
        this.cerrarDialogCorteMasivo()
        this.seleccionCortePeriodo = []
        this.validarSuccess(mensaje)
        this.refrescarTrasAccionCorte()
      }).catch((error) => {
        const body = (error && error.response && error.response.data) || (error && error.body) || null
        if (body && body.code === 'CORTE_EFECTIVO_DIFERENCIA_MASIVO' && Array.isArray(body.dias)) {
          for (const dif of body.dias) {
            const dia = form.dias.find((el) => el.fecha_corte === dif.fecha_corte)
            if (!dia) continue
            if (Number.isFinite(Number(dif.suma_efectivo))) dia.efectivo_corte = Number(dif.suma_efectivo)
            if (Array.isArray(dif.ids_ingresos)) dia.ids_efectivo = dif.ids_ingresos
            dia.error = `El efectivo del sistema es ${this.formatMoneda(dif.suma_efectivo)}`
          }
        }
        form.error = (body && body.message) || ''
        this.validarError(error)
      }).finally(() => { this.cargar = false })
    },

    aceptarCorte( item ){

      this.cargar = true

      item.estatus = 1

      this.$http.post("aceptar.corte", item).then((response) => {
        this.cargar = false
        this.refrescarTrasAccionCorte()
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });

    },

    formatMoneda(valor) {
      const n = Number(valor)
      if (!Number.isFinite(n)) return '—'
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n)
    },

    /** Recibido / Folio / Estatus: sin plantel → todos; con plantel → solo el consultado. */
    esPlantelConsultado(item) {
      if (!item) return false
      if (this.plantel == null || this.plantel === '') return true
      return Number(item.id_plantel) === Number(this.plantel)
    },

    /** URL de archivo en /comprobante-pago vía base del API (local/staging/prod). */
    urlComprobantePago(nombre) {
      if (!nombre) return ''
      const base = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '')
        .replace(/\/?$/, '/')
      if (base && base !== '/') {
        return base + 'comprobante-pago/' + nombre
      }
      const fallback = String(this.url_servidor || '').replace(/\/?$/, '/')
      return fallback + 'comprobante-pago/' + nombre
    },

    idsEfectivoPlantelCorte(idPlantel) {
      const all = [...(this.plantelesInbi || []), ...(this.plantelesFast || [])]
      const row = all.find((el) => Number(el.id_plantel) === Number(idPlantel))
      if (row && Array.isArray(row.ids_efectivo_corte) && row.ids_efectivo_corte.length) {
        return row.ids_efectivo_corte
      }
      const movs = Array.isArray(this.tablaMovimientos) ? this.tablaMovimientos : []
      return movs
        .filter((el) => {
          if (!el) return false
          const mismoPlantel =
            Number(el.id_plantel_ingreso) === Number(idPlantel) ||
            Number(el.id_plantel) === Number(idPlantel)
          const esEfectivo =
            Number(el.id_forma_pago) === 1 ||
            String(el.forma_pago || '').toUpperCase() === 'EFECTIVO'
          return mismoPlantel && esEfectivo
        })
        .map((el) => el.id_ingreso)
        .filter((id) => id != null)
    },

    abrirDialogCorteEfectivo(item) {
      if (!this.puedeRegistrarCorteEfectivo || !item) return
      const evidencias = Array.isArray(item.evidencias_corte) ? [...item.evidencias_corte] : []
      // Solo el monto ya registrado en el corte; no sustituir con la suma de ingresos.
      const montoPrev =
        item.monto_recibido != null && item.monto_recibido !== ''
          ? Number(item.monto_recibido)
          : null
      // Preferir ids de la fila (día × plantel). No mezclar con movimientos de otra fecha en pantalla.
      const idsCorte = Array.isArray(item.ids_efectivo_corte) && item.ids_efectivo_corte.length
        ? [...item.ids_efectivo_corte]
        : (item.fecha_corte && String(item.fecha_corte) !== String(this.fecha_corte)
          ? []
          : this.idsEfectivoPlantelCorte(item.id_plantel))
      const efectivoVista =
        item.efectivo_num != null && item.efectivo_num !== ''
          ? Number(item.efectivo_num)
          : Number(item.efectivo)
      this.corteEfectivoForm = {
        id_plantel: item.id_plantel,
        plantel: item.plantel,
        fecha_corte: item.fecha_corte || this.fecha_corte,
        idvalidar_corte: item.idvalidar_corte || null,
        folio_corte: item.folio_corte || null,
        // Efectivo de la ventana de corte (contra esto se valida al guardar).
        efectivo_corte: Number.isFinite(efectivoVista) ? efectivoVista : 0,
        ids_efectivo: idsCorte,
        monto_recibido: Number.isFinite(montoPrev) ? montoPrev : null,
        evidencias_existentes: evidencias,
      }
      this.limpiarArchivosCorteNuevos()
      this.dialogCorteEfectivo = true
      this.limpiarErrorCorteEfectivo()
    },

    limpiarErrorCorteEfectivo() {
      this.errorCorteEfectivoVisible = false
      this.mensajeErrorCorteEfectivo = ''
    },

    cerrarDialogCorteEfectivo() {
      this.dialogCorteEfectivo = false
      this.corteEfectivoForm = null
      this.limpiarArchivosCorteNuevos()
      this.limpiarErrorCorteEfectivo()
      if (this.$refs.inputFotosCorte) this.$refs.inputFotosCorte.value = ''
    },

    limpiarArchivosCorteNuevos() {
      const lista = Array.isArray(this.archivosCorteNuevos) ? this.archivosCorteNuevos : []
      for (const item of lista) {
        if (item && item.previewUrl) {
          try { URL.revokeObjectURL(item.previewUrl) } catch (e) { /* ignore */ }
        }
      }
      this.archivosCorteNuevos = []
    },

    onSeleccionarFotosCorte(event) {
      const files = event && event.target && event.target.files
        ? Array.from(event.target.files)
        : []
      if (!files.length) return
      const actuales = Array.isArray(this.archivosCorteNuevos) ? [...this.archivosCorteNuevos] : []
      for (const file of files) {
        if (!file) continue
        const duplicado = actuales.some(
          (item) => {
            const f = item && item.file
            return f && f.name === file.name && f.size === file.size && f.lastModified === file.lastModified
          }
        )
        if (!duplicado) {
          actuales.push({
            file,
            previewUrl: URL.createObjectURL(file),
          })
        }
      }
      this.archivosCorteNuevos = actuales
      if (event && event.target) event.target.value = ''
    },

    quitarArchivoCorteNuevo(indice) {
      if (!Array.isArray(this.archivosCorteNuevos)) return
      const item = this.archivosCorteNuevos[indice]
      if (item && item.previewUrl) {
        try { URL.revokeObjectURL(item.previewUrl) } catch (e) { /* ignore */ }
      }
      this.archivosCorteNuevos = this.archivosCorteNuevos.filter((_, i) => i !== indice)
    },

    abrirPreviewArchivosNuevos(indice = 0) {
      const lista = Array.isArray(this.archivosCorteNuevos) ? this.archivosCorteNuevos : []
      const urls = lista.map((item) => item && item.previewUrl).filter(Boolean)
      if (!urls.length) return
      const idx = Math.max(0, Math.min(Number(indice) || 0, urls.length - 1))
      this.baseUrlVisor = ''
      this.imagen = urls[idx]
      this.imagenesVisor = urls.map((foto) => ({ foto }))
      this.indiceImagenVisor = idx
      this.dialgImagen = true
    },

    quitarEvidenciaExistente(indice) {
      if (!this.corteEfectivoForm || !Array.isArray(this.corteEfectivoForm.evidencias_existentes)) return
      this.corteEfectivoForm.evidencias_existentes = this.corteEfectivoForm.evidencias_existentes.filter(
        (_, i) => i !== indice
      )
    },

    abrirEvidenciaCorte(nombre, indice = 0) {
      if (!nombre) return
      const lista = (this.corteEfectivoForm && Array.isArray(this.corteEfectivoForm.evidencias_existentes))
        ? this.corteEfectivoForm.evidencias_existentes
        : [nombre]
      this.abrirVisorImagenes(lista, indice)
    },

    abrirVisorImagenes(lista, indice = 0) {
      const nombres = (Array.isArray(lista) ? lista : [lista])
        .map((e) => String(e || '').trim())
        .filter(Boolean)
      if (!nombres.length) return
      const idx = Math.max(0, Math.min(Number(indice) || 0, nombres.length - 1))
      this.baseUrlVisor = this.baseUrlComprobante
      this.imagen = nombres[idx]
      this.imagenesVisor = nombres.map((foto) => ({ foto }))
      this.indiceImagenVisor = idx
      this.dialgImagen = true
    },

    async subirEvidenciasCorte(archivos) {
      const nombres = []
      for (const file of archivos) {
        const formData = new FormData()
        formData.append('file', file)
        const response = await this.$http.post('grabar.comprobante', formData)
        if (response && response.data && response.data.nombre) {
          nombres.push(response.data.nombre)
        }
      }
      return nombres
    },

    async guardarCorteEfectivo() {
      if (!this.corteEfectivoForm || !this.puedeRegistrarCorteEfectivo) return

      const form = this.corteEfectivoForm
      const monto = Number(form.monto_recibido)
      if (!Number.isFinite(monto) || monto < 0) {
        this.validarError('Ingresa un monto recibido válido')
        return
      }

      const sumaSistema = Number(form.efectivo_corte) || 0
      const diferencia = Math.round((monto - sumaSistema) * 100) / 100
      if (Math.abs(diferencia) >= 0.01) {
        this.errorCorteEfectivoVisible = true
        this.mensajeErrorCorteEfectivo =
          `El monto recibido (${this.formatMoneda(monto)}) no coincide con el efectivo del corte (${this.formatMoneda(sumaSistema)}). Diferencia: ${diferencia > 0 ? '+' : ''}${this.formatMoneda(diferencia)}.`
        const ids = Array.isArray(form.ids_efectivo) ? form.ids_efectivo : []
        const idsTexto = ids.length
          ? ` Ingresos: ${ids.join(', ')}.`
          : ''
        this.validarError(
          `No se puede aceptar el corte: ${this.mensajeErrorCorteEfectivo}${idsTexto}`
        )
        return
      }
      this.limpiarErrorCorteEfectivo()

      const nuevos = this.archivosCorteNuevosFiles

      let evidencias = Array.isArray(form.evidencias_existentes) ? [...form.evidencias_existentes] : []
      if (nuevos.length) {
        try {
          this.cargar = true
          const subidas = await this.subirEvidenciasCorte(nuevos)
          evidencias = evidencias.concat(subidas)
        } catch (error) {
          this.validarError(error)
          this.cargar = false
          return
        }
      }

      if (!evidencias.length) {
        this.cargar = false
        this.validarError('Sube al menos una evidencia fotográfica')
        return
      }

      const payload = {
        id_plantel: form.id_plantel,
        fecha_corte: form.fecha_corte,
        idvalidar_corte: form.idvalidar_corte,
        monto_recibido: monto,
        evidencias_corte: evidencias,
        ids_ingresos: Array.isArray(form.ids_efectivo) ? form.ids_efectivo : this.idsEfectivoPlantelCorte(form.id_plantel),
      }

      this.cargar = true
      this.$http.post('registrar.corte.efectivo', payload).then(() => {
        this.limpiarArchivosCorteNuevos()
        this.cerrarDialogCorteEfectivo()
        this.refrescarTrasAccionCorte()
      }).catch((error) => {
        const body = (error && error.response && error.response.data) || (error && error.body) || null
        if (body && body.code === 'CORTE_EFECTIVO_DIFERENCIA') {
          this.errorCorteEfectivoVisible = true
          this.mensajeErrorCorteEfectivo = body.message || this.mensajeErrorCorteEfectivo
          // Si el servidor recalculó otro monto, alinear el diálogo para reintentar.
          if (body.suma_efectivo != null && Number.isFinite(Number(body.suma_efectivo))) {
            this.corteEfectivoForm.efectivo_corte = Number(body.suma_efectivo)
          }
          if (Array.isArray(body.ids_ingresos)) {
            this.corteEfectivoForm.ids_efectivo = body.ids_ingresos
          }
        }
        this.validarError(error)
      }).finally(() => { this.cargar = false })
    },

    solicitarRevision( ){
      this.cargar = true

      this.$http.post("solicitar.revision.corte", this.miCorte).then((response) => {
        this.cargar = false
        this.consultar( )
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    confirmarRechazo( data ){
      this.datosPago = data
      this.dialogConfirma = true
    },

    rechazarComprobante( data ){

      this.cargar = true

      data.estatus = 2
      data.motivo  = this.motivo

      this.$http.post("aceptar.corte", data).then((response) => {
        this.cargar = false
        this.dialogConfirma = false
        this.motivo = ''
        this.refrescarTrasAccionCorte()
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    getDiferenciaCiclos() {

      var payload = {
        id_ciclo: this.cicloDiferencia,
      };

      this.cargar = true

      this.diferencias = []
      this.$http.post("inscripciones.comparaciones.ciclo", payload).then((response) => {
        this.cargar = false
        this.diferencias = response.data;
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    abrirDialog(value) {
      console.log(value);
      this.alumnos = value;
      this.dialogCifras = true;
    },

    exportar(value) {
      this.exportExcel(value);
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportExcel(value) {
      let data = XLSX.utils.json_to_sheet(value);
      const workbook = XLSX.utils.book_new();
      const filename = "cifras_" + this.plantel;
      XLSX.utils.book_append_sheet(workbook, data, filename);

      var wbout = XLSX.write(workbook, {
        bookType: "xls",
        bookSST: false,
        type: "binary",
      });

      const file = new File([new Blob([this.s2ab(wbout)])], filename + ".xls");

      let formData = new FormData();
      // //se crea el objeto y se le agrega como un apendice el archivo
      formData.append("file", file);
      // /*getDatosRiesgo the form data*/

      this.$http
        .post("pdfs", formData)
        .then((response) => {
          window.location =
            axios.defaults.baseURL + "pdfs/" + filename + ".xls";
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    verImagen(value) {            //Angel Rodriguez
      this.abrirVisorImagenes([value], 0)
    },

    cerrarDialogImagen() {
      this.dialgImagen = false
      this.imagen = null
      this.imagenesVisor = []
      this.indiceImagenVisor = 0
    },

    generarRecibo( ){

      const existePlantel = this.planteles.find( el => el.id_plantel == this.plantel )

      var payload = {
        desglose: this.tablaMovimientos,
        montos  : this.tablaPagosSucursal,
        usuario : this.getdatosUsuarioERPERP.nombre_completo,
        fecha   : this.fecha_corte,
        plantel : existePlantel ? existePlantel.plantel : ''
      };

      this.cargar = true

      this.diferencias = []

      this.$http.post("corte.recibo", payload).then((response) => {

        this.cargar = false

        const url = axios.defaults.baseURL + 'recibo-pago/' + response.data.folio + '.pdf'

        window.open( url )

        this.validarSuccess( response.data.message )

      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    exportar2( ){

      const alumnos = this.tablaMovimientos.map(({ id_ingreso, fecha_pago, monto_pagado, alumno, ciclo, plantel }) => ({ id_ingreso, fecha_pago, monto_pagado, alumno, ciclo, plantel }));

      this.exportExcel( alumnos)

    }
  },
};
</script>
